/**
 * Simple slide down
 * Be sure to set the element's height to 0px, overflow: hidden and css transition for height
 * @param {Element} element
 */
export function slideDown(element) {
  // eslint-disable-next-line no-param-reassign
  element.style.height = `${element.scrollHeight}px`;
}

/**
 * Slide up
 * Be sure to set the element's overflow: hidden
 * and css transition for height
 * @param element
 */
export function slideUp(element) {
  // eslint-disable-next-line no-param-reassign
  element.style.height = '0px';
}
